(function () {
  const initHero = (section) => {
    if (!section || !section?.classList.contains("hero-section")) {
      return;
    }

    // Hero videos ship with preload="none" and no autoplay (see
    // sections/hero.liquid): start them only after the page has loaded so
    // the streams never race the LCP image on slow networks.
    // 2026-07-27 (operator: "video frozen as a picture"): the single
    // window-load play() dies silently whenever the browser defers media
    // at that exact moment (backgrounded load, Low Power Mode, data
    // saver) and nothing ever retried — a frozen poster forever. Keep the
    // load-time start, then retry on every signal playback may now be
    // allowed: page becomes visible, hero enters view, first touch
    // (a user gesture unlocks Low Power Mode's autoplay block).
    const startVideos = () => {
      section.querySelectorAll("video[data-hero-video]").forEach((v) => {
        if (v.paused) v.play().catch(() => {});
      });
    };
    if (document.readyState === "complete") {
      startVideos();
    } else {
      window.addEventListener("load", startVideos, { once: true });
    }
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) startVideos();
    });
    ["pointerdown", "touchstart"].forEach((ev) =>
      document.addEventListener(ev, startVideos,
        { once: true, passive: true, capture: true }));
    if ("IntersectionObserver" in window) {
      new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) startVideos();
      }, { threshold: 0.1 }).observe(section);
    }

    const slider = section.querySelector(".hero__media--slider");

    if (!slider) return;

    const sliderWrapper = slider.querySelector(".hero__media-wrapper");
    const sliderSpeed = Number(slider.dataset?.sliderSpeed || 15000);
    const sliderSpeedMob = sliderSpeed * 0.8;
    const sliderDirection = slider.dataset?.sliderDirection || "right_to_left";
    const reverseDirection = sliderDirection === "left_to_right" ? true : false;
    const pageDir = document.documentElement.getAttribute("dir") || "ltr";
    let initialOffset = pageDir === "ltr" ? "-40%" : "40%";
    if (reverseDirection) {
      initialOffset = 0;
    }

    const initSlider = () => {
      new Swiper(slider, {
        loop: true,
        allowTouchMove: false,
        spaceBetween: 0,
        speed: sliderSpeedMob,
        slidesPerView: "auto",
        resizeObserver: false,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: reverseDirection,
        },
        breakpoints: {
          576: {
            speed: sliderSpeed,
          },
        },
        on: {
          init: function () {
            if (!sliderWrapper) return;
            sliderWrapper.style.transform = `translate3d(${initialOffset}, 0, 0)`;
          },
        },
      });
    };

    // Init only once the slider has real width. Before layout the container
    // measures 0, slidesPerView:"auto" counts every slide as visible, and
    // Swiper logs "not enough slides for loop mode" + computes loop math from
    // garbage widths. Timed fallback so a hidden hero can never stall init.
    if (slider.clientWidth > 0 || typeof ResizeObserver === "undefined") {
      initSlider();
    } else {
      let inited = false;
      const settle = () => {
        if (inited || slider.swiper) return;
        inited = true;
        ro.disconnect();
        initSlider();
      };
      const ro = new ResizeObserver(() => {
        if (slider.clientWidth > 0) settle();
      });
      ro.observe(slider);
      setTimeout(settle, 2000);
    }
  };

  initHero(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initHero(event.target);
  });
})();
